import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.scss';
import App from './App';
import ScrollToTop from './components/scroll-to-top/ScrollToTop';
import { UserProvider } from './context/UserContext';
import './i18n';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const callback = {};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(

  <BrowserRouter >
    <UserProvider>
      <ScrollToTop />
      <App callback={callback} />
    </UserProvider>
  </BrowserRouter>
);

serviceWorkerRegistration.register({
  onUpdate: () => {
    if (callback.onUpdate) {
      callback.onUpdate();
    }
  }
});

